import {IssuePersonalData} from "../domain/entities/issue-personal-data.entity";
import {CommandName} from "./command-name.enum";
import {AbstractCommand} from "./abstract.command";

/**
 * Clears `personalLabel` on an existing row (Issue dragged back into the
 * unassigned column). See `UnassignIssueFromPersonalLabelCommandHandler`.
 *
 * `mainEntityClass`/`mainEntityUid`: see `CreateIssuePersonalDataCommand`'s own
 * doc comment (must point at this row, never at the referenced Issue).
 */
export class UnassignIssueFromPersonalLabelCommand extends AbstractCommand<IssuePersonalData> {

    name = CommandName.UNASSIGN_ISSUE_FROM_PERSONAL_LABEL;

    tags = ['entity', 'unassign', 'issue-personal-data'];

}
